import { getContrastRatio as Nt, lighten as un, darken as mn, createTheme as pn, unstable_defaultSxConfig as dn, unstable_styleFunctionSx as gn } from "@mui/system";
/*! @license DOMPurify 3.1.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.5/LICENSE */
const {
  entries: Wt,
  setPrototypeOf: Dt,
  isFrozen: hn,
  getPrototypeOf: Tn,
  getOwnPropertyDescriptor: bn
} = Object;
let {
  freeze: C,
  seal: F,
  create: jt
} = Object, {
  apply: qe,
  construct: Ke
} = typeof Reflect < "u" && Reflect;
C || (C = function(n) {
  return n;
});
F || (F = function(n) {
  return n;
});
qe || (qe = function(n, r, i) {
  return n.apply(r, i);
});
Ke || (Ke = function(n, r) {
  return new n(...r);
});
const Se = U(Array.prototype.forEach), It = U(Array.prototype.pop), pe = U(Array.prototype.push), De = U(String.prototype.toLowerCase), je = U(String.prototype.toString), wt = U(String.prototype.match), de = U(String.prototype.replace), _n = U(String.prototype.indexOf), En = U(String.prototype.trim), $ = U(Object.prototype.hasOwnProperty), L = U(RegExp.prototype.test), ge = An(TypeError);
function U(t) {
  return function(n) {
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return qe(t, n, i);
  };
}
function An(t) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return Ke(t, r);
  };
}
function f(t, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : De;
  Dt && Dt(t, null);
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const p = r(a);
      p !== a && (hn(n) || (n[i] = p), a = p);
    }
    t[a] = !0;
  }
  return t;
}
function yn(t) {
  for (let n = 0; n < t.length; n++)
    $(t, n) || (t[n] = null);
  return t;
}
function X(t) {
  const n = jt(null);
  for (const [r, i] of Wt(t))
    $(t, r) && (Array.isArray(i) ? n[r] = yn(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = X(i) : n[r] = i);
  return n;
}
function Re(t, n) {
  for (; t !== null; ) {
    const i = bn(t, n);
    if (i) {
      if (i.get)
        return U(i.get);
      if (typeof i.value == "function")
        return U(i.value);
    }
    t = Tn(t);
  }
  function r() {
    return null;
  }
  return r;
}
const Mt = C(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Ge = C(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Be = C(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), On = C(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Ve = C(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Sn = C(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Lt = C(["#text"]), Ct = C(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ye = C(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), xt = C(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Ne = C(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Rn = F(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Nn = F(/<%[\w\W]*|[\w\W]*%>/gm), Dn = F(/\${[\w\W]*}/gm), In = F(/^data-[\-\w.\u00B7-\uFFFF]/), wn = F(/^aria-[\-\w]+$/), Gt = F(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Mn = F(/^(?:\w+script|data):/i), Ln = F(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Bt = F(/^html$/i), Cn = F(/^[a-z][.\w]*(-[.\w]+)+$/i);
var vt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: Rn,
  ERB_EXPR: Nn,
  TMPLIT_EXPR: Dn,
  DATA_ATTR: In,
  ARIA_ATTR: wn,
  IS_ALLOWED_URI: Gt,
  IS_SCRIPT_OR_DATA: Mn,
  ATTR_WHITESPACE: Ln,
  DOCTYPE_NAME: Bt,
  CUSTOM_ELEMENT: Cn
});
const he = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, xn = function() {
  return typeof window > "u" ? null : window;
}, vn = function(n, r) {
  if (typeof n != "object" || typeof n.createPolicy != "function")
    return null;
  let i = null;
  const a = "data-tt-policy-suffix";
  r && r.hasAttribute(a) && (i = r.getAttribute(a));
  const p = "dompurify" + (i ? "#" + i : "");
  try {
    return n.createPolicy(p, {
      createHTML(u) {
        return u;
      },
      createScriptURL(u) {
        return u;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + p + " could not be created."), null;
  }
};
function Vt() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : xn();
  const n = (c) => Vt(c);
  if (n.version = "3.1.5", n.removed = [], !t || !t.document || t.document.nodeType !== he.document)
    return n.isSupported = !1, n;
  let {
    document: r
  } = t;
  const i = r, a = i.currentScript, {
    DocumentFragment: p,
    HTMLTemplateElement: u,
    Node: R,
    Element: D,
    NodeFilter: d,
    NamedNodeMap: O = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: I,
    DOMParser: g,
    trustedTypes: x
  } = t, w = D.prototype, l = Re(w, "cloneNode"), b = Re(w, "nextSibling"), P = Re(w, "childNodes"), B = Re(w, "parentNode");
  if (typeof u == "function") {
    const c = r.createElement("template");
    c.content && c.content.ownerDocument && (r = c.content.ownerDocument);
  }
  let _, V = "";
  const {
    implementation: ce,
    createNodeIterator: Xt,
    createDocumentFragment: qt,
    getElementsByTagName: Kt
  } = r, {
    importNode: Zt
  } = i;
  let z = {};
  n.isSupported = typeof Wt == "function" && typeof B == "function" && ce && ce.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: Me,
    ERB_EXPR: Le,
    TMPLIT_EXPR: Ce,
    DATA_ATTR: Jt,
    ARIA_ATTR: Qt,
    IS_SCRIPT_OR_DATA: en,
    ATTR_WHITESPACE: Je,
    CUSTOM_ELEMENT: tn
  } = vt;
  let {
    IS_ALLOWED_URI: Qe
  } = vt, E = null;
  const et = f({}, [...Mt, ...Ge, ...Be, ...Ve, ...Lt]);
  let A = null;
  const tt = f({}, [...Ct, ...Ye, ...xt, ...Ne]);
  let T = Object.seal(jt(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), le = null, xe = null, nt = !0, ve = !0, rt = !1, ot = !0, q = !1, ke = !0, Y = !1, Pe = !1, Ue = !1, K = !1, _e = !1, Ee = !1, it = !0, at = !1;
  const nn = "user-content-";
  let Fe = !0, fe = !1, Z = {}, J = null;
  const st = f({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let ct = null;
  const lt = f({}, ["audio", "video", "img", "source", "image", "track"]);
  let $e = null;
  const ft = f({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Ae = "http://www.w3.org/1998/Math/MathML", ye = "http://www.w3.org/2000/svg", j = "http://www.w3.org/1999/xhtml";
  let Q = j, ze = !1, He = null;
  const rn = f({}, [Ae, ye, j], je);
  let ue = null;
  const on = ["application/xhtml+xml", "text/html"], an = "text/html";
  let y = null, ee = null;
  const sn = r.createElement("form"), ut = function(e) {
    return e instanceof RegExp || e instanceof Function;
  }, We = function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(ee && ee === e)) {
      if ((!e || typeof e != "object") && (e = {}), e = X(e), ue = // eslint-disable-next-line unicorn/prefer-includes
      on.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? an : e.PARSER_MEDIA_TYPE, y = ue === "application/xhtml+xml" ? je : De, E = $(e, "ALLOWED_TAGS") ? f({}, e.ALLOWED_TAGS, y) : et, A = $(e, "ALLOWED_ATTR") ? f({}, e.ALLOWED_ATTR, y) : tt, He = $(e, "ALLOWED_NAMESPACES") ? f({}, e.ALLOWED_NAMESPACES, je) : rn, $e = $(e, "ADD_URI_SAFE_ATTR") ? f(
        X(ft),
        // eslint-disable-line indent
        e.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        y
        // eslint-disable-line indent
      ) : ft, ct = $(e, "ADD_DATA_URI_TAGS") ? f(
        X(lt),
        // eslint-disable-line indent
        e.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        y
        // eslint-disable-line indent
      ) : lt, J = $(e, "FORBID_CONTENTS") ? f({}, e.FORBID_CONTENTS, y) : st, le = $(e, "FORBID_TAGS") ? f({}, e.FORBID_TAGS, y) : {}, xe = $(e, "FORBID_ATTR") ? f({}, e.FORBID_ATTR, y) : {}, Z = $(e, "USE_PROFILES") ? e.USE_PROFILES : !1, nt = e.ALLOW_ARIA_ATTR !== !1, ve = e.ALLOW_DATA_ATTR !== !1, rt = e.ALLOW_UNKNOWN_PROTOCOLS || !1, ot = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, q = e.SAFE_FOR_TEMPLATES || !1, ke = e.SAFE_FOR_XML !== !1, Y = e.WHOLE_DOCUMENT || !1, K = e.RETURN_DOM || !1, _e = e.RETURN_DOM_FRAGMENT || !1, Ee = e.RETURN_TRUSTED_TYPE || !1, Ue = e.FORCE_BODY || !1, it = e.SANITIZE_DOM !== !1, at = e.SANITIZE_NAMED_PROPS || !1, Fe = e.KEEP_CONTENT !== !1, fe = e.IN_PLACE || !1, Qe = e.ALLOWED_URI_REGEXP || Gt, Q = e.NAMESPACE || j, T = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && ut(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (T.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && ut(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (T.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (T.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), q && (ve = !1), _e && (K = !0), Z && (E = f({}, Lt), A = [], Z.html === !0 && (f(E, Mt), f(A, Ct)), Z.svg === !0 && (f(E, Ge), f(A, Ye), f(A, Ne)), Z.svgFilters === !0 && (f(E, Be), f(A, Ye), f(A, Ne)), Z.mathMl === !0 && (f(E, Ve), f(A, xt), f(A, Ne))), e.ADD_TAGS && (E === et && (E = X(E)), f(E, e.ADD_TAGS, y)), e.ADD_ATTR && (A === tt && (A = X(A)), f(A, e.ADD_ATTR, y)), e.ADD_URI_SAFE_ATTR && f($e, e.ADD_URI_SAFE_ATTR, y), e.FORBID_CONTENTS && (J === st && (J = X(J)), f(J, e.FORBID_CONTENTS, y)), Fe && (E["#text"] = !0), Y && f(E, ["html", "head", "body"]), E.table && (f(E, ["tbody"]), delete le.tbody), e.TRUSTED_TYPES_POLICY) {
        if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw ge('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw ge('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        _ = e.TRUSTED_TYPES_POLICY, V = _.createHTML("");
      } else
        _ === void 0 && (_ = vn(x, a)), _ !== null && typeof V == "string" && (V = _.createHTML(""));
      C && C(e), ee = e;
    }
  }, mt = f({}, ["mi", "mo", "mn", "ms", "mtext"]), pt = f({}, ["foreignobject", "annotation-xml"]), cn = f({}, ["title", "style", "font", "a", "script"]), dt = f({}, [...Ge, ...Be, ...On]), gt = f({}, [...Ve, ...Sn]), ln = function(e) {
    let o = B(e);
    (!o || !o.tagName) && (o = {
      namespaceURI: Q,
      tagName: "template"
    });
    const s = De(e.tagName), m = De(o.tagName);
    return He[e.namespaceURI] ? e.namespaceURI === ye ? o.namespaceURI === j ? s === "svg" : o.namespaceURI === Ae ? s === "svg" && (m === "annotation-xml" || mt[m]) : !!dt[s] : e.namespaceURI === Ae ? o.namespaceURI === j ? s === "math" : o.namespaceURI === ye ? s === "math" && pt[m] : !!gt[s] : e.namespaceURI === j ? o.namespaceURI === ye && !pt[m] || o.namespaceURI === Ae && !mt[m] ? !1 : !gt[s] && (cn[s] || !dt[s]) : !!(ue === "application/xhtml+xml" && He[e.namespaceURI]) : !1;
  }, H = function(e) {
    pe(n.removed, {
      element: e
    });
    try {
      e.parentNode.removeChild(e);
    } catch {
      e.remove();
    }
  }, Oe = function(e, o) {
    try {
      pe(n.removed, {
        attribute: o.getAttributeNode(e),
        from: o
      });
    } catch {
      pe(n.removed, {
        attribute: null,
        from: o
      });
    }
    if (o.removeAttribute(e), e === "is" && !A[e])
      if (K || _e)
        try {
          H(o);
        } catch {
        }
      else
        try {
          o.setAttribute(e, "");
        } catch {
        }
  }, ht = function(e) {
    let o = null, s = null;
    if (Ue)
      e = "<remove></remove>" + e;
    else {
      const S = wt(e, /^[\r\n\t ]+/);
      s = S && S[0];
    }
    ue === "application/xhtml+xml" && Q === j && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
    const m = _ ? _.createHTML(e) : e;
    if (Q === j)
      try {
        o = new g().parseFromString(m, ue);
      } catch {
      }
    if (!o || !o.documentElement) {
      o = ce.createDocument(Q, "template", null);
      try {
        o.documentElement.innerHTML = ze ? V : m;
      } catch {
      }
    }
    const N = o.body || o.documentElement;
    return e && s && N.insertBefore(r.createTextNode(s), N.childNodes[0] || null), Q === j ? Kt.call(o, Y ? "html" : "body")[0] : Y ? o.documentElement : N;
  }, Tt = function(e) {
    return Xt.call(
      e.ownerDocument || e,
      e,
      // eslint-disable-next-line no-bitwise
      d.SHOW_ELEMENT | d.SHOW_COMMENT | d.SHOW_TEXT | d.SHOW_PROCESSING_INSTRUCTION | d.SHOW_CDATA_SECTION,
      null
    );
  }, bt = function(e) {
    return e instanceof I && (typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || !(e.attributes instanceof O) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function");
  }, _t = function(e) {
    return typeof R == "function" && e instanceof R;
  }, G = function(e, o, s) {
    z[e] && Se(z[e], (m) => {
      m.call(n, o, s, ee);
    });
  }, Et = function(e) {
    let o = null;
    if (G("beforeSanitizeElements", e, null), bt(e))
      return H(e), !0;
    const s = y(e.nodeName);
    if (G("uponSanitizeElement", e, {
      tagName: s,
      allowedTags: E
    }), e.hasChildNodes() && !_t(e.firstElementChild) && L(/<[/\w]/g, e.innerHTML) && L(/<[/\w]/g, e.textContent) || e.nodeType === he.progressingInstruction || ke && e.nodeType === he.comment && L(/<[/\w]/g, e.data))
      return H(e), !0;
    if (!E[s] || le[s]) {
      if (!le[s] && yt(s) && (T.tagNameCheck instanceof RegExp && L(T.tagNameCheck, s) || T.tagNameCheck instanceof Function && T.tagNameCheck(s)))
        return !1;
      if (Fe && !J[s]) {
        const m = B(e) || e.parentNode, N = P(e) || e.childNodes;
        if (N && m) {
          const S = N.length;
          for (let v = S - 1; v >= 0; --v) {
            const W = l(N[v], !0);
            W.__removalCount = (e.__removalCount || 0) + 1, m.insertBefore(W, b(e));
          }
        }
      }
      return H(e), !0;
    }
    return e instanceof D && !ln(e) || (s === "noscript" || s === "noembed" || s === "noframes") && L(/<\/no(script|embed|frames)/i, e.innerHTML) ? (H(e), !0) : (q && e.nodeType === he.text && (o = e.textContent, Se([Me, Le, Ce], (m) => {
      o = de(o, m, " ");
    }), e.textContent !== o && (pe(n.removed, {
      element: e.cloneNode()
    }), e.textContent = o)), G("afterSanitizeElements", e, null), !1);
  }, At = function(e, o, s) {
    if (it && (o === "id" || o === "name") && (s in r || s in sn))
      return !1;
    if (!(ve && !xe[o] && L(Jt, o))) {
      if (!(nt && L(Qt, o))) {
        if (!A[o] || xe[o]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(yt(e) && (T.tagNameCheck instanceof RegExp && L(T.tagNameCheck, e) || T.tagNameCheck instanceof Function && T.tagNameCheck(e)) && (T.attributeNameCheck instanceof RegExp && L(T.attributeNameCheck, o) || T.attributeNameCheck instanceof Function && T.attributeNameCheck(o)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            o === "is" && T.allowCustomizedBuiltInElements && (T.tagNameCheck instanceof RegExp && L(T.tagNameCheck, s) || T.tagNameCheck instanceof Function && T.tagNameCheck(s)))
          )
            return !1;
        } else if (!$e[o]) {
          if (!L(Qe, de(s, Je, ""))) {
            if (!((o === "src" || o === "xlink:href" || o === "href") && e !== "script" && _n(s, "data:") === 0 && ct[e])) {
              if (!(rt && !L(en, de(s, Je, "")))) {
                if (s)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, yt = function(e) {
    return e !== "annotation-xml" && wt(e, tn);
  }, Ot = function(e) {
    G("beforeSanitizeAttributes", e, null);
    const {
      attributes: o
    } = e;
    if (!o)
      return;
    const s = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: A
    };
    let m = o.length;
    for (; m--; ) {
      const N = o[m], {
        name: S,
        namespaceURI: v,
        value: W
      } = N, me = y(S);
      let M = S === "value" ? W : En(W);
      if (s.attrName = me, s.attrValue = M, s.keepAttr = !0, s.forceKeepAttr = void 0, G("uponSanitizeAttribute", e, s), M = s.attrValue, s.forceKeepAttr || (Oe(S, e), !s.keepAttr))
        continue;
      if (!ot && L(/\/>/i, M)) {
        Oe(S, e);
        continue;
      }
      if (ke && L(/((--!?|])>)|<\/(style|title)/i, M)) {
        Oe(S, e);
        continue;
      }
      q && Se([Me, Le, Ce], (Rt) => {
        M = de(M, Rt, " ");
      });
      const St = y(e.nodeName);
      if (At(St, me, M)) {
        if (at && (me === "id" || me === "name") && (Oe(S, e), M = nn + M), _ && typeof x == "object" && typeof x.getAttributeType == "function" && !v)
          switch (x.getAttributeType(St, me)) {
            case "TrustedHTML": {
              M = _.createHTML(M);
              break;
            }
            case "TrustedScriptURL": {
              M = _.createScriptURL(M);
              break;
            }
          }
        try {
          v ? e.setAttributeNS(v, S, M) : e.setAttribute(S, M), bt(e) ? H(e) : It(n.removed);
        } catch {
        }
      }
    }
    G("afterSanitizeAttributes", e, null);
  }, fn = function c(e) {
    let o = null;
    const s = Tt(e);
    for (G("beforeSanitizeShadowDOM", e, null); o = s.nextNode(); )
      G("uponSanitizeShadowNode", o, null), !Et(o) && (o.content instanceof p && c(o.content), Ot(o));
    G("afterSanitizeShadowDOM", e, null);
  };
  return n.sanitize = function(c) {
    let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = null, s = null, m = null, N = null;
    if (ze = !c, ze && (c = "<!-->"), typeof c != "string" && !_t(c))
      if (typeof c.toString == "function") {
        if (c = c.toString(), typeof c != "string")
          throw ge("dirty is not a string, aborting");
      } else
        throw ge("toString is not a function");
    if (!n.isSupported)
      return c;
    if (Pe || We(e), n.removed = [], typeof c == "string" && (fe = !1), fe) {
      if (c.nodeName) {
        const W = y(c.nodeName);
        if (!E[W] || le[W])
          throw ge("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (c instanceof R)
      o = ht("<!---->"), s = o.ownerDocument.importNode(c, !0), s.nodeType === he.element && s.nodeName === "BODY" || s.nodeName === "HTML" ? o = s : o.appendChild(s);
    else {
      if (!K && !q && !Y && // eslint-disable-next-line unicorn/prefer-includes
      c.indexOf("<") === -1)
        return _ && Ee ? _.createHTML(c) : c;
      if (o = ht(c), !o)
        return K ? null : Ee ? V : "";
    }
    o && Ue && H(o.firstChild);
    const S = Tt(fe ? c : o);
    for (; m = S.nextNode(); )
      Et(m) || (m.content instanceof p && fn(m.content), Ot(m));
    if (fe)
      return c;
    if (K) {
      if (_e)
        for (N = qt.call(o.ownerDocument); o.firstChild; )
          N.appendChild(o.firstChild);
      else
        N = o;
      return (A.shadowroot || A.shadowrootmode) && (N = Zt.call(i, N, !0)), N;
    }
    let v = Y ? o.outerHTML : o.innerHTML;
    return Y && E["!doctype"] && o.ownerDocument && o.ownerDocument.doctype && o.ownerDocument.doctype.name && L(Bt, o.ownerDocument.doctype.name) && (v = "<!DOCTYPE " + o.ownerDocument.doctype.name + `>
` + v), q && Se([Me, Le, Ce], (W) => {
      v = de(v, W, " ");
    }), _ && Ee ? _.createHTML(v) : v;
  }, n.setConfig = function() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    We(c), Pe = !0;
  }, n.clearConfig = function() {
    ee = null, Pe = !1;
  }, n.isValidAttribute = function(c, e, o) {
    ee || We({});
    const s = y(c), m = y(e);
    return At(s, m, o);
  }, n.addHook = function(c, e) {
    typeof e == "function" && (z[c] = z[c] || [], pe(z[c], e));
  }, n.removeHook = function(c) {
    if (z[c])
      return It(z[c]);
  }, n.removeHooks = function(c) {
    z[c] && (z[c] = []);
  }, n.removeAllHooks = function() {
    z = {};
  }, n;
}
var kn = Vt();
const Ie = (t) => t === null || typeof t > "u";
function Pn(t) {
  return Ie(t) ? !1 : typeof t == "object" && !Array.isArray(t);
}
const Or = (...t) => t.map((n) => typeof n == "function" ? n() : Pn(n) ? Object.entries(n).filter(([, r]) => r).map(([r]) => r).join(" ") : n).filter((n) => n).join(" "), Sr = (t, n, r = void 0) => (n == null ? void 0 : n.replace(/\[([^\[\]]*)\]/g, ".$1.").split(".").filter((i) => i !== "").reduce((i, a) => i && i[a], t)) ?? r, Rr = () => {
}, Nr = (t) => Ie(t) ? {} : Object.keys(t).reduce((n, r) => (r.startsWith("data-") && (n[r] = t[r]), n), {}), kt = (t) => typeof t == "string" ? t.trim() : typeof t == "number" ? (
  // added type number because isEmpty will return true for number type
  t.toString()
) : t, Dr = (t) => Ie(t) || !(Object.keys(kt(t)) || kt(t)).length, Ir = (t, n = 0) => {
  let r;
  return function(...i) {
    clearTimeout(r), r = setTimeout(() => t.apply(this, i), n);
  };
};
function wr(t, n = 0) {
  const r = parseInt(t.target.min, 10) || 0, i = parseInt(t.target.max, 10) || null;
  let a = t.target.value;
  a = r >= 0 ? a.replace(/[^0-9.]/g, "") : a.replace(/[^-?0-9.]/g, "");
  const p = /\.$/.test(a), u = /^-/.test(a);
  return a.trim() === "" ? "" : u && (a === "-" || Number(a) === 0) ? a : (a = Number(a), Number.isNaN(a) ? (a = "", a) : (n > 0 ? a = Math.round(a * Math.pow(10, n)) / Math.pow(10, n) : a = parseInt(`${a}`, 10), a < r ? a = r : !Ie(i) && a > i && (a = i), n > 0 && p && (a = `${a}.`), a));
}
const Mr = (t) => t ? kn.sanitize(t) : "";
function k() {
  return k = Object.assign ? Object.assign.bind() : function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var i in r)
        ({}).hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, k.apply(null, arguments);
}
function ae(t) {
  if (typeof t != "object" || t === null)
    return !1;
  const n = Object.getPrototypeOf(t);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}
function Yt(t) {
  if (!ae(t))
    return t;
  const n = {};
  return Object.keys(t).forEach((r) => {
    n[r] = Yt(t[r]);
  }), n;
}
function se(t, n, r = {
  clone: !0
}) {
  const i = r.clone ? k({}, t) : t;
  return ae(t) && ae(n) && Object.keys(n).forEach((a) => {
    a !== "__proto__" && (ae(n[a]) && a in t && ae(t[a]) ? i[a] = se(t[a], n[a], r) : r.clone ? i[a] = ae(n[a]) ? Yt(n[a]) : n[a] : i[a] = n[a]);
  }), i;
}
var Lr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Cr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function xr(t) {
  if (t.__esModule)
    return t;
  var n = t.default;
  if (typeof n == "function") {
    var r = function i() {
      return this instanceof i ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    r.prototype = n.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(i) {
    var a = Object.getOwnPropertyDescriptor(t, i);
    Object.defineProperty(r, i, a.get ? a : {
      enumerable: !0,
      get: function() {
        return t[i];
      }
    });
  }), r;
}
function Ze(t) {
  let n = "https://mui.com/production-error/?code=" + t;
  for (let r = 1; r < arguments.length; r += 1)
    n += "&args[]=" + encodeURIComponent(arguments[r]);
  return "Minified MUI error #" + t + "; visit " + n + " for the full message.";
}
const Pt = (t) => t, Un = () => {
  let t = Pt;
  return {
    configure(n) {
      t = n;
    },
    generate(n) {
      return t(n);
    },
    reset() {
      t = Pt;
    }
  };
}, Fn = Un(), $n = Fn, zn = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Hn(t, n, r = "Mui") {
  const i = zn[n];
  return i ? `${r}-${i}` : `${$n.generate(t)}-${n}`;
}
function we(t, n) {
  if (t == null)
    return {};
  var r = {};
  for (var i in t)
    if ({}.hasOwnProperty.call(t, i)) {
      if (n.includes(i))
        continue;
      r[i] = t[i];
    }
  return r;
}
function Wn(t, n) {
  return k({
    toolbar: {
      minHeight: 56,
      [t.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [t.up("sm")]: {
        minHeight: 64
      }
    }
  }, n);
}
const jn = {
  black: "#000",
  white: "#fff"
}, be = jn, Gn = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Bn = Gn, Vn = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, te = Vn, Yn = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, ne = Yn, Xn = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Te = Xn, qn = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, re = qn, Kn = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, oe = Kn, Zn = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, ie = Zn, Jn = ["mode", "contrastThreshold", "tonalOffset"], Ut = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: be.white,
    default: be.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, Xe = {
  text: {
    primary: be.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: be.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function Ft(t, n, r, i) {
  const a = i.light || i, p = i.dark || i * 1.5;
  t[n] || (t.hasOwnProperty(r) ? t[n] = t[r] : n === "light" ? t.light = un(t.main, a) : n === "dark" && (t.dark = mn(t.main, p)));
}
function Qn(t = "light") {
  return t === "dark" ? {
    main: re[200],
    light: re[50],
    dark: re[400]
  } : {
    main: re[700],
    light: re[400],
    dark: re[800]
  };
}
function er(t = "light") {
  return t === "dark" ? {
    main: te[200],
    light: te[50],
    dark: te[400]
  } : {
    main: te[500],
    light: te[300],
    dark: te[700]
  };
}
function tr(t = "light") {
  return t === "dark" ? {
    main: ne[500],
    light: ne[300],
    dark: ne[700]
  } : {
    main: ne[700],
    light: ne[400],
    dark: ne[800]
  };
}
function nr(t = "light") {
  return t === "dark" ? {
    main: oe[400],
    light: oe[300],
    dark: oe[700]
  } : {
    main: oe[700],
    light: oe[500],
    dark: oe[900]
  };
}
function rr(t = "light") {
  return t === "dark" ? {
    main: ie[400],
    light: ie[300],
    dark: ie[700]
  } : {
    main: ie[800],
    light: ie[500],
    dark: ie[900]
  };
}
function or(t = "light") {
  return t === "dark" ? {
    main: Te[400],
    light: Te[300],
    dark: Te[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Te[500],
    dark: Te[900]
  };
}
function ir(t) {
  const {
    mode: n = "light",
    contrastThreshold: r = 3,
    tonalOffset: i = 0.2
  } = t, a = we(t, Jn), p = t.primary || Qn(n), u = t.secondary || er(n), R = t.error || tr(n), D = t.info || nr(n), d = t.success || rr(n), O = t.warning || or(n);
  function I(l) {
    const b = Nt(l, Xe.text.primary) >= r ? Xe.text.primary : Ut.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const P = Nt(l, b);
      P < 3 && console.error([`MUI: The contrast ratio of ${P}:1 for ${b} on ${l}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return b;
  }
  const g = ({
    color: l,
    name: b,
    mainShade: P = 500,
    lightShade: B = 300,
    darkShade: _ = 700
  }) => {
    if (l = k({}, l), !l.main && l[P] && (l.main = l[P]), !l.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${b ? ` (${b})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${P}\` property.` : Ze(11, b ? ` (${b})` : "", P));
    if (typeof l.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${b ? ` (${b})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(l.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Ze(12, b ? ` (${b})` : "", JSON.stringify(l.main)));
    return Ft(l, "light", B, i), Ft(l, "dark", _, i), l.contrastText || (l.contrastText = I(l.main)), l;
  }, x = {
    dark: Xe,
    light: Ut
  };
  return process.env.NODE_ENV !== "production" && (x[n] || console.error(`MUI: The palette mode \`${n}\` is not supported.`)), se(k({
    // A collection of common colors.
    common: k({}, be),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: n,
    // The colors used to represent primary interface elements for a user.
    primary: g({
      color: p,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: g({
      color: u,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: g({
      color: R,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: g({
      color: O,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: g({
      color: D,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: g({
      color: d,
      name: "success"
    }),
    // The grey colors.
    grey: Bn,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: r,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: I,
    // Generate a rich color object.
    augmentColor: g,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: i
  }, x[n]), a);
}
const ar = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function sr(t) {
  return Math.round(t * 1e5) / 1e5;
}
const $t = {
  textTransform: "uppercase"
}, zt = '"Roboto", "Helvetica", "Arial", sans-serif';
function cr(t, n) {
  const r = typeof n == "function" ? n(t) : n, {
    fontFamily: i = zt,
    // The default font size of the Material Specification.
    fontSize: a = 14,
    // px
    fontWeightLight: p = 300,
    fontWeightRegular: u = 400,
    fontWeightMedium: R = 500,
    fontWeightBold: D = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: d = 16,
    // Apply the CSS properties to all the variants.
    allVariants: O,
    pxToRem: I
  } = r, g = we(r, ar);
  process.env.NODE_ENV !== "production" && (typeof a != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof d != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const x = a / 14, w = I || ((P) => `${P / d * x}rem`), l = (P, B, _, V, ce) => k({
    fontFamily: i,
    fontWeight: P,
    fontSize: w(B),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: _
  }, i === zt ? {
    letterSpacing: `${sr(V / B)}em`
  } : {}, ce, O), b = {
    h1: l(p, 96, 1.167, -1.5),
    h2: l(p, 60, 1.2, -0.5),
    h3: l(u, 48, 1.167, 0),
    h4: l(u, 34, 1.235, 0.25),
    h5: l(u, 24, 1.334, 0),
    h6: l(R, 20, 1.6, 0.15),
    subtitle1: l(u, 16, 1.75, 0.15),
    subtitle2: l(R, 14, 1.57, 0.1),
    body1: l(u, 16, 1.5, 0.15),
    body2: l(u, 14, 1.43, 0.15),
    button: l(R, 14, 1.75, 0.4, $t),
    caption: l(u, 12, 1.66, 0.4),
    overline: l(u, 12, 2.66, 1, $t),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return se(k({
    htmlFontSize: d,
    pxToRem: w,
    fontFamily: i,
    fontSize: a,
    fontWeightLight: p,
    fontWeightRegular: u,
    fontWeightMedium: R,
    fontWeightBold: D
  }, b), g, {
    clone: !1
    // No need to clone deep
  });
}
const lr = 0.2, fr = 0.14, ur = 0.12;
function h(...t) {
  return [`${t[0]}px ${t[1]}px ${t[2]}px ${t[3]}px rgba(0,0,0,${lr})`, `${t[4]}px ${t[5]}px ${t[6]}px ${t[7]}px rgba(0,0,0,${fr})`, `${t[8]}px ${t[9]}px ${t[10]}px ${t[11]}px rgba(0,0,0,${ur})`].join(",");
}
const mr = ["none", h(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), h(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), h(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), h(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), h(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), h(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), h(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), h(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), h(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), h(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), h(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), h(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), h(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), h(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), h(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), h(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), h(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), h(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), h(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), h(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), h(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), h(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), h(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), h(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], pr = mr, dr = ["duration", "easing", "delay"], gr = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, hr = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function Ht(t) {
  return `${Math.round(t)}ms`;
}
function Tr(t) {
  if (!t)
    return 0;
  const n = t / 36;
  return Math.round((4 + 15 * n ** 0.25 + n / 5) * 10);
}
function br(t) {
  const n = k({}, gr, t.easing), r = k({}, hr, t.duration);
  return k({
    getAutoHeightDuration: Tr,
    create: (a = ["all"], p = {}) => {
      const {
        duration: u = r.standard,
        easing: R = n.easeInOut,
        delay: D = 0
      } = p, d = we(p, dr);
      if (process.env.NODE_ENV !== "production") {
        const O = (g) => typeof g == "string", I = (g) => !isNaN(parseFloat(g));
        !O(a) && !Array.isArray(a) && console.error('MUI: Argument "props" must be a string or Array.'), !I(u) && !O(u) && console.error(`MUI: Argument "duration" must be a number or a string but found ${u}.`), O(R) || console.error('MUI: Argument "easing" must be a string.'), !I(D) && !O(D) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof p != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(d).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(d).join(",")}].`);
      }
      return (Array.isArray(a) ? a : [a]).map((O) => `${O} ${typeof u == "string" ? u : Ht(u)} ${R} ${typeof D == "string" ? D : Ht(D)}`).join(",");
    }
  }, t, {
    easing: n,
    duration: r
  });
}
const _r = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, Er = _r, Ar = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function vr(t = {}, ...n) {
  const {
    mixins: r = {},
    palette: i = {},
    transitions: a = {},
    typography: p = {}
  } = t, u = we(t, Ar);
  if (t.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : Ze(18));
  const R = ir(i), D = pn(t);
  let d = se(D, {
    mixins: Wn(D.breakpoints, r),
    palette: R,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: pr.slice(),
    typography: cr(R, p),
    transitions: br(a),
    zIndex: k({}, Er)
  });
  if (d = se(d, u), d = n.reduce((O, I) => se(O, I), d), process.env.NODE_ENV !== "production") {
    const O = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], I = (g, x) => {
      let w;
      for (w in g) {
        const l = g[w];
        if (O.indexOf(w) !== -1 && Object.keys(l).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const b = Hn("", w);
            console.error([`MUI: The \`${x}\` component increases the CSS specificity of the \`${w}\` internal state.`, "You can not override it like this: ", JSON.stringify(g, null, 2), "", `Instead, you need to use the '&.${b}' syntax:`, JSON.stringify({
              root: {
                [`&.${b}`]: l
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          g[w] = {};
        }
      }
    };
    Object.keys(d.components).forEach((g) => {
      const x = d.components[g].styleOverrides;
      x && g.indexOf("Mui") === 0 && I(x, g);
    });
  }
  return d.unstable_sxConfig = k({}, dn, u == null ? void 0 : u.unstable_sxConfig), d.unstable_sx = function(I) {
    return gn({
      sx: I,
      theme: this
    });
  }, d;
}
export {
  $n as C,
  we as _,
  k as a,
  Or as b,
  vr as c,
  Cr as d,
  Lr as e,
  Ir as f,
  Sr as g,
  Nr as h,
  Ie as i,
  wr as j,
  Dr as k,
  Ze as l,
  Hn as m,
  Rr as n,
  xr as o,
  Mr as s
};
//# sourceMappingURL=createTheme-feb5b756.js.map
